module.exports = __webpack_public_path__ + "img/coupon4.10e92242.png";